import { render, staticRenderFns } from "./mstrbudgetaddition-my.vue?vue&type=template&id=57439b04"
import script from "./mstrbudgetaddition-my.vue?vue&type=script&lang=js"
export * from "./mstrbudgetaddition-my.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports